<template>
  <div>
    <v-card :elevation="$root.ele" class="mt-4 mb-4">
      <v-data-table
        :headers="headers"
        class="templates-table"
        :search="search"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, -1],
        }"
        :items-per-page="50"
        :items="list"
      >
        <template v-slot:top="{ pagination, options, updateOptions }">
          <div class="d-flex align-center pl-4 pt-2 pb-2 pr-0">
            <v-select
              :items="reports"
              class="report_type"
              v-model="reportType"
              item-text="name"
              item-value="value"
              label="Select Report Type"
              hide-details=""
              outlined
              dense
            >
              <template v-slot:append-outer>
                <v-btn
                  depressed
                  height="40px"
                  class="primary"
                  @click="generateReport"
                  tile
                >
                  Generate
                </v-btn>
              </template>
            </v-select>
            <v-spacer></v-spacer>
            <v-data-footer
              class="top-footer"
              :items-per-page-options="[10, 20, 50, -1]"
              :pagination="pagination"
              :options="options"
              :items-per-page="100"
              @update:options="updateOptions"
              items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            />
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <div v-if="isAdmin || isDispatcher || isDataEntryAndDispatcher" class="d-flex">
            <v-btn icon @click="$router.push(`/jobs/${item.id}`)">
              <v-icon> mdi-pencil </v-icon>
            </v-btn>
            <v-btn v-if="isAdmin" icon color="red" @click="remove(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn icon @click="openChat(item)">
              <v-icon> mdi-chat-processing-outline </v-icon>
            </v-btn>
            <dispatch-job
              @onDispatched="$emit('onDispatched')"
              :item="item"
              v-if="isDispatch(item)"
            ></dispatch-job>
          </div>
        </template>
        <template v-slot:item.print="{ item }">
          <v-btn icon @click="print(item)">
            <v-icon> mdi-printer </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.phone="{ item }">
          <a :href="`tel:${item.fields.Phone}`">
            {{ formatPhone(item.fields.Phone) }}
          </a>
        </template>
        <template v-slot:item.template="{ item }">
          {{ getTemplate(item) }}</template
        >
        <template v-slot:item.job_number="{ item }">
          <a :href="`/dispatch-sheet?date=${getDate(item)}`" target="_blank">
            {{ item.job_number }}
          </a>
        </template>
        <template v-slot:item.updated_by="{ item }">
          {{ updated(item) }}</template
        >
        <template v-slot:item.status="{ item }">
          {{ getJobStatus(item) }}</template
        >
      </v-data-table>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>
<script>
import types from "../../assets/js/types";
import smsList from "../../assets/js/sms_status";
import smsColor from "../../assets/js/sms_color";
import generateReport from "../../assets/print/general.report.js";
import {
  formatDateOnly,
  formatMessage,
  formatPhone,
  getAppointmentWindow,
  getDateOnly,
} from "../../assets/js/common";
import DispatchJob from "./DispatchJob.vue";
import moment from "moment";
import customerModal from "../../assets/js/customer.modal";
import { customers } from "../../assets/js/firebase";
import customerMixins from "../../assets/js/customer.mixins.js";
export default {
  components: {
    DispatchJob,
  },
  mixins: [customerMixins],
  data() {
    return {
      lastDoc: null,
      reportType: "",
      types: types,
      isMobile: window.innerWidth < 768,
      search: "",
      id: "",
      reports: [
        {
          name: "General Report",
          value: "general",
        },
        {
          name: "Tax Report",
          value: "tax",
        },
      ],
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "CREATE DATE", value: "created_at" },
        { text: "JOB NUMBER", value: "job_number" },
        { text: "NAME", value: "name" },
        { text: "PHONE", value: "phone" },
        { text: "JOB TYPE", value: "template" },
        { text: "JOB STATUS", value: "status" },
        // { text: "UPDATED ON", value: "updated_at" },
        // { text: "UPDATED BY", value: "updated_by" },
        { text: "Technician", value: "technician_name" },
        { text: "PRINT", value: "print" },
        { text: "ACTION", value: "action" },
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true,
          filterable: false,
        };
        if (value === "sms") doc.width = "150px";
        if (value === "name") doc.filterable = true;
        if (value === "job_number") doc.filterable = true;
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    templates() {
      return this.$store.getters.templates;
    },
    list() {
      return this.$store.getters.jobs.map((item) => {
        item.technician_name = this.getTechnician(item);
        return item;
      });
    },
    users() {
      return this.$store.getters.users;
    },
    dispositions() {
      return this.$store.getters.dispositions;
    },
  },
  methods: {
    async remove({ id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete this Job",
        onConfirm: async () => {
          try {
            vm.$root.loader = true;
            await customers.doc(id).delete();
            vm.$emit("onJobRemove");
            vm.$root.loader = false;
            vm.$root.alert("Job removed successfully");
          } catch (error) {
            vm.$root.loader = true;
            vm.$root.alert(error.message);
          }
        },
      });
    },
    getDate({ disposition_date }) {
      if (disposition_date) return disposition_date.split("T")[0];
      return getDateOnly();
    },
    getDisposition({ disposition }) {
      console.log(disposition);
      let item = this.dispositions.find((item) => {
        return item.id == disposition;
      });
      return item instanceof Object ? item.name : "";
    },
    generateReport() {
      if (this.reportType == "tax") {
        this.generateTax();
      }
      if (this.reportType == "general") {
        this.generateGeneral();
      }
    },
    generateGeneral() {
      const vm = this;
      let { updated_at } = vm.$store.getters.jobQuery;
      let start = formatDateOnly(updated_at[0]);
      let end = formatDateOnly(updated_at[1]);
      let body = "";
      let total_amount = 0;
      let total_credit_charge = 0;
      let total_tax = 0;
      for (let item of vm.list) {
        let {
          template_name,
          job_number,
          created_at,
          fields,
          invoice,
          charges,
          name,
        } = item;
        let disposition = vm.getDisposition(item);
        if (!invoice) invoice = "";
        let tax = fields[customerModal.TAX];
        let amount = fields[customerModal.TOTAL];
        if (tax !== undefined && amount != undefined) {
          amount = parseFloat(amount);
          if (isNaN(tax)) tax = 0;
          if (isNaN(charges)) charges = 0;
          if (isNaN(amount)) amount = 0;
          amount = amount - parseFloat(tax) - parseFloat(charges);
          amount = amount.toFixed(2);
          if (item.disposition == customerModal.DISPOSITION_COMPLETE) {
            total_amount = total_amount + parseFloat(amount);
            total_tax = total_tax + parseFloat(tax);
            total_credit_charge = total_credit_charge + parseFloat(charges);
          }
          let tr = `<tr>
            <td>${created_at}</td>
            <td>${job_number}</td>
            <td>${invoice}</td>
            <td>${template_name}</td>
            <td>${name}</td>
            <td>${disposition}</td>
            <td>${charges}</td>
            <td>${tax}</td>
            <td>${amount}</td>
        </tr>`;
          body += tr;
        }
      }
      let html = generateReport;
      html = html.split("from_date").join(start);
      html = html.split("to_date").join(end);
      html = html
        .split("total_credit_charge")
        .join(total_credit_charge.toFixed(2));
      html = html.split("total_amount").join(total_amount.toFixed(2));
      html = html.split("total_tax").join(total_tax.toFixed(2));
      html = html.split("table_body").join(body);
      let win = window.open("about:blank", "_blank");
      win.document.write(html);
      win.document.close();
      win.print();
    },
    generateTax() {
      const vm = this;
      let { updated_at } = vm.$store.getters.jobQuery;
      let start = formatDateOnly(updated_at[0]);
      let end = formatDateOnly(updated_at[1]);
      let body = "";
      let total_amount = 0;
      let total_tax = 0;
      let total_sales = 0;
      let total_non_tax_sales = 0;
      for (let item of vm.list) {
        let {
          template_name,
          job_number,
          created_at,
          fields,
          charges,
          status,
          disposition,
        } = item;
        let tax = fields[customerModal.TAX];
        let amount = fields[customerModal.TOTAL];
        let taxAmount = fields[customerModal.TAXABLE_AMOUNT];
        if (status == 7 && disposition == customerModal.DISPOSITION_COMPLETE) {
          if (tax != undefined && amount != undefined) {
            amount = parseFloat(amount);
            tax = parseFloat(tax);
            taxAmount = parseFloat(taxAmount);
            charges = parseFloat(charges);
            if (isNaN(amount)) amount = 0;
            if (isNaN(tax)) tax = 0;
            if (isNaN(charges)) charges = 0;
            if (isNaN(taxAmount)) taxAmount = 0;
            let tr = `<tr>
            <td>${created_at}</td>
            <td>${job_number}</td>
            <td>${template_name}</td>
            <td>${amount.toFixed(2)}</td>
            <td>${tax}</td>
        </tr>`;
            if (tax > 0) {
              body += tr;
            }
            total_tax = total_tax + tax;
            total_non_tax_sales =
              total_non_tax_sales + (amount - taxAmount - charges - tax);
            total_amount = total_amount + taxAmount;
            total_sales = total_sales + (amount - charges);
          }
        }
      }
      let { html } = require("../../assets/print/tax.js");
      html = html.split("from_date").join(start);
      html = html.split("to_date").join(end);
      html = html.split("total_amount").join(total_amount.toFixed(2));
      html = html.split("total_tax").join(total_tax.toFixed(2));
      html = html.split("total_sales").join(total_sales.toFixed(2));
      html = html
        .split("total_non_tax_sales")
        .join(total_non_tax_sales.toFixed(2));
      html = html.split("table_body").join(body);
      html;
      let win = window.open("about:blank", "_blank");
      win.document.write(html);
      win.document.close();
      win.print();
    },
    getTechnician({ technician }) {
      if (!technician) return "";
      let tech = this.$store.getters.technicians.find((item) => {
        return item.id === technician;
      });
      return tech != null ? tech.name : "";
    },
   async print(item) {
      let { template_name, created_at, name, job_number, disposition } = item;
      let date = moment(created_at, "MM/DD/YYYY hh:mm a");
      let contract_date = date.format("MM/DD/YYYY");
      let contract_time = date.format("hh:mm a");
      let { html } = require("../../assets/print/contract.js");
      let div = document.createElement("div");
      div.innerHTML = html;
      try {
        const jobDoc = await customers.doc(item.id).get();
        const jobData = jobDoc.data();
        if (disposition != customerModal.DISPOSITION_COMPLETE) {
          div.querySelector("#watermark").remove();
        }else{
          let watermarkText = "COMPLETED & PAID";
          
          if (jobData.fields && jobData.fields.completion_status) {
            if (jobData.fields.completion_status === "completed_paid") {
              watermarkText = "COMPLETED & PAID";
            } else if (jobData.fields.completion_status === "completed_not_paid") {
              watermarkText = "PLEASE PAY INVOICE IMMEDIATELY";
            }
          }
          const watermarkElement = div.querySelector("#watermark h1");
          if (watermarkElement) {
            watermarkElement.textContent = watermarkText;
          }
        }
      } catch (error) {
        console.error('Error fetching job data:', error);
      }
      html = div.innerHTML;
      html = html.split("template_name").join(template_name);
      html = html.split("customer_name").join(name);
      html = html.split("{job_number}").join(job_number);
      html = html.split("contract_date").join(contract_date);
      html = html.split("contract_time").join(contract_time);
      item.fields[customerModal.APPOINTMENT_TIME_WINDOW] =
        getAppointmentWindow(item);
      let msg = formatMessage(item);
      html = html.split("contract_message").join(msg);
      let win = window.open("about:blank", "_blank");
      win.document.write(html);
      win.document.close();
      win.print();
    },
    isDispatch(item) {
      let status = [1, 2, 5, 6];
      return status.indexOf(item.status) != -1;
    },
    openChat(item) {
      let phone = item.fields.Phone;
      let { name } = item;
      if (this.isMobile) {
        this.$router.push({
          path: `/sms-view/${phone}`,
          query: {
            id: phone,
            name: name,
            phone,
          },
        });
      } else {
        this.$router.push({
          path: `/sms`,
          query: {
            id: phone,
            name: name,
            phone,
          },
        });
      }
    },
    updated({ updated_by }) {
      let name = updated_by;
      this.users.forEach((item) => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    formatPhone(phone) {
      return formatPhone(phone);
    },
    sms({ sms_status }) {
      let i = 0;
      sms_status.forEach(({ status }) => {
        if (status === "d") i++;
      });
      let len = sms_status.length;
      let percent = (i * 100) / len;
      return Math.round(percent);
    },
    smsSend({ sms_status }) {
      let i = 0;
      sms_status.forEach(({ status }) => {
        if (status === "d") i++;
      });
      let l = sms_status.length;
      return `${i}/${l} sent`;
    },
    formatSMS({ sms }) {
      return smsList[sms];
    },
    SMScolor({ sms }) {
      return smsColor[sms];
    },
    getTemplate({ template }) {
      let name = "";
      const vm = this;
      vm.templates.forEach((item) => {
        if (item.id === template) name = item.name;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach((item) => {
        if (item.value === type) name = item.name;
      });
      return name;
    },
  },
};
</script>

<style lang="scss">
.report_type {
  max-width: 300px;
  .v-input__append-outer {
    margin: 0px !important;
  }
}
</style>
